import { Action, CookieState } from '../interface';
import * as actionTypes from '../store/action-types';
import { findCookieValue } from '../util/utility';

const cookieValue = findCookieValue('cookie_policy');

const initialState: CookieState = {
	notShowCookie: cookieValue || false,
};

export const CookieReducer = (state: CookieState = initialState, action: Action): CookieState => {
	switch (action.type) {
		case actionTypes.SHOW_COOKIE:
			return {
				...state,
				notShowCookie: action.payload.notShowCookie.notShowCookie,
			};
		default: {
			return state;
		}
	}
};
